/* ============================================================
   JOWI — analytics-setup.js
   GA4 + Meta Pixel + TikTok Pixel + A/B testing
   El GA4 measurement ID se inyecta vía Shopify Web Pixels API
   (Online Store → Customer Events) y aquí actuamos como puente
   para eventos custom del tema (cart drawer, popups, search).
   ============================================================ */
(function () {
  'use strict';

  // ---------- GA4 helper ----------
  function gaEvent(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...(params || {}) });
  }

  // ---------- Pageview enrichment ----------
  // Shopify Analytics ya envía pageview automáticamente, pero
  // enriquecemos con datos del template para reports custom.
  const tplBody = document.body.className.match(/template-([\w-]+)/);
  if (tplBody) {
    gaEvent('page_view', {
      template: tplBody[1],
      locale: document.documentElement.lang,
      currency: (window.ShopThemeConfig && window.ShopThemeConfig.currency) || 'USD'
    });
  }

  // ---------- A/B Test runner ----------
  const AB_STORAGE = 'mga_ab_variants_v1';
  function loadVariants() {
    try { return JSON.parse(localStorage.getItem(AB_STORAGE) || '{}'); }
    catch { return {}; }
  }
  function saveVariants(v) { try { localStorage.setItem(AB_STORAGE, JSON.stringify(v)); } catch {} }

  function getVariant(testId, variants) {
    const stored = loadVariants();
    if (stored[testId] && variants.includes(stored[testId])) return stored[testId];
    const idx = Math.floor(Math.random() * variants.length);
    const variant = variants[idx];
    stored[testId] = variant;
    saveVariants(stored);
    gaEvent('ab_test_assigned', { test_id: testId, variant });
    return variant;
  }

  // Lee data-ab-test del DOM
  document.querySelectorAll('[data-ab-test]').forEach((el) => {
    const testId = el.dataset.abTest;
    const variants = (el.dataset.abVariants || 'A,B').split(',');
    const chosen = getVariant(testId, variants);
    el.querySelectorAll('[data-ab-variant]').forEach((v) => {
      v.hidden = v.dataset.abVariant !== chosen;
    });
    gaEvent('ab_test_exposure', { test_id: testId, variant: chosen });
  });

  // ---------- Theme event bridge ----------
  document.addEventListener('cart:item-added', (e) => {
    gaEvent('add_to_cart', {
      currency: (window.ShopThemeConfig && window.ShopThemeConfig.currency) || 'USD'
    });
  });

  document.addEventListener('cart:updated', (e) => {
    const c = e.detail || {};
    gaEvent('view_cart', {
      currency: (window.ShopThemeConfig && window.ShopThemeConfig.currency) || 'USD',
      value: ((c.items_subtotal_price || c.total_price || 0) / 100)
    });
  });

  // Search interactions
  const searchInput = document.querySelector('[data-search-input]');
  if (searchInput) {
    let lastTerm = '';
    let timeout;
    searchInput.addEventListener('input', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const term = searchInput.value.trim();
        if (term.length >= 3 && term !== lastTerm) {
          lastTerm = term;
          gaEvent('search', { search_term: term });
        }
      }, 800);
    });
  }

  // PDP view → view_item (con SKU)
  const productForm = document.querySelector('[data-product-form-section]');
  if (productForm) {
    const variantSel = productForm.querySelector('[data-variant-id]');
    const productData = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (productData) {
      gaEvent('view_item', {
        currency: (window.ShopThemeConfig && window.ShopThemeConfig.currency) || 'USD',
        items: [{
          item_id: productData.id,
          item_name: productData.variants?.[0]?.name,
          price: (productData.variants?.[0]?.price || 0) / 100
        }]
      });
    }
  }

  // Begin checkout (Cart drawer button)
  document.addEventListener('click', (e) => {
    if (e.target.matches('button[name="checkout"], a[href="/checkout"]')) {
      gaEvent('begin_checkout', {
        currency: (window.ShopThemeConfig && window.ShopThemeConfig.currency) || 'USD'
      });
    }
  });

  // Expose for sections
  window.ShopThemeAnalytics = { gaEvent, getVariant };
})();
